module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "size": "medium",
      "top": "5%",
      "show-close": false
    },
    model: {
      value: (_vm.mostraFormulario),
      callback: function($$v) {
        _vm.mostraFormulario = $$v
      },
      expression: "mostraFormulario"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    }
  }, [_vm._v("Quer transformar sua MEI em ME?")])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('h3', [_vm._v("Somos um Escritório de Contabilidade Online que migra sua MEI para ME e faz sua contabilidade de um jeito simples, moderno e online.")]), _vm._v(" "), _c('h4', [_vm._v("Conte com a orientação e o trabalho de especialistas para começar certo!")]), _vm._v(" "), _c('h5', [_vm._v("Preencha agora mesmo o formulário e receba uma cotação de nossos serviços")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    key: "form",
    attrs: {
      "element-loading-text": "Enviando os dados, aguarde..."
    }
  }, [_c('el-form', {
    ref: "form",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Seu nome (Obrigatório)",
      "prop": "nome"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.nome),
      callback: function($$v) {
        _vm.form.nome = $$v
      },
      expression: "form.nome"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email (Obrigatório)",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Telefone com DDD (Somente números)",
      "prop": "telefone"
    }
  }, [_c('div', {
    staticClass: "el-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.telefone),
      expression: "form.telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.mascaraTelefone),
      expression: "mascaraTelefone"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": "Fixo ou Celular"
    },
    domProps: {
      "value": (_vm.form.telefone)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.form.telefone = $event.target.value
      }, _vm.atualizaMascara]
    }
  })])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "selecionadas"
    }
  }, [_c('label', {
    staticClass: "el-form-item__label",
    staticStyle: {
      "width": "100%",
      "text-align": "left"
    }
  }, [_vm._v("Qual tipo de empresa você quer migrar para ME (Obrigatório)\"")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.form.selecionadas),
      callback: function($$v) {
        _vm.form.selecionadas = $$v
      },
      expression: "form.selecionadas"
    }
  }, _vm._l((_vm.form.opcoes), function(opcao) {
    return _c('el-checkbox', {
      key: opcao,
      staticStyle: {
        "font-weight": "normal"
      },
      attrs: {
        "label": opcao
      }
    }, [_vm._v(_vm._s(opcao))])
  }))], 1), _vm._v(" "), _c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": _vm.sitekey,
      "badge": "inline",
      "size": "invisible"
    },
    on: {
      "verify": _vm.verifyRecaptcha,
      "expired": _vm.recaptchaExpired
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "disabled": !_vm.isValid,
      "type": "success"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_vm._v("Enviar")])], 1)], 1)], 1)])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.mostraFormulario = true
      }
    }
  }, [_vm._v("Migrar MEI para ME")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e10128ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MeiParaMe.vue
// module id = 85
// module chunks = 1